'use client'

import { isErrorReported } from '@repo/observability/errors'
import NextError from 'next/error'
import { useEffect } from 'react'

import { logger } from '@/lib/observability/logger'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (isErrorReported(error)) return

    logger.fatal(error, { route: 'global-error' })
  }, [error])

  return (
    <html lang="en">
      <body>
        {/* This is the default Next.js error component but it doesn't allow omitting the statusCode property yet. */}
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
